import {
  AppInstallOrigin,
  IntentInstallOptions,
} from '@wix/editor-platform-host-integration-apis';
import {
  EditorType,
  InstallInitiator,
  InstallationOriginType,
} from '@wix/editor-platform-sdk-types';
import { getEditorInfo } from '../../../../utils';
import { IntentInstallErrorCode, createIntentInstallError } from '../errors';

export function getOriginInfoType(isSilent?: boolean) {
  return isSilent
    ? InstallationOriginType.SILENT_INSTALL
    : InstallationOriginType.INTENT_INSTALL;
}

export function getOrigin(options: IntentInstallOptions): AppInstallOrigin {
  if (options.installOrigin) {
    return options.installOrigin;
  }

  const originType = (() => {
    const host = getEditorInfo()?.host;
    switch (host) {
      case 'EDITOR':
        return EditorType.Classic;
      case 'EDITOR_X':
      case 'STUDIO':
        return EditorType.Responsive;
      case undefined:
        throw createIntentInstallError(IntentInstallErrorCode.NoHostDetected);
      default:
        throw createIntentInstallError(
          IntentInstallErrorCode.UnknownHost,
        ).withHost(host);
    }
  })();

  return {
    type: originType,
    initiator: InstallInitiator.Editor,
    info: {
      type: getOriginInfoType(options.isSilent),
    },
  };
}
